export default {"src":"/_next/static/media/cranberries.a5fb377c.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};